// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	box-sizing: border-box;
	padding: 0;
	margin: 0;
}

img {
	max-width: 100%;
}

a {
	text-decoration: none;
}

.signup_alert_main {
	height: 63px;
	display: flex;
	border-radius: 5px;
	background-color: rgb(249, 215, 216);
}

.signup_alert1 {
	height: 100%;
	background-color: rgb(229, 75, 77);
	color: #dfd1d1;
	width: 8%;
	text-align: center;
	padding-top: 15px;
	border-radius: 5px;
}

.signup_alert2 {
	padding-left: 10px;
	padding-top: 15px;
	width: 92%;
	color: rgb(106, 34, 36);
}


/* Outer: full-viewport scroll shell only (no grid centering — that clips tall content at the top). */
.signup_page {
	position: fixed;
	overflow-x: auto;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	inset: 0;
	box-sizing: border-box;
	background: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);
}

/* Inner: centers logo + card when short; grows with content when tall so scroll starts from top — no top clip. */
.signup_page_inner {
	box-sizing: border-box;
	width: 100%;
	min-height: 100vh;
	min-height: 100dvh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	padding-top: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-top));
	padding-right: max(0.75rem, env(safe-area-inset-right));
	padding-bottom: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-bottom));
	padding-left: max(0.75rem, env(safe-area-inset-left));
}

.page_logo {
	width: 100%;
	display: flex;
	flex-flow: wrap;
	gap: 0px;
	justify-content: center;
	align-items: center;
	text-align: center;
}

.page_logo a {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	column-gap: 0.25rem;
	color: rgb(67, 70, 206);
	overflow-wrap: anywhere;
}

/* Wordmark: modest size; subtle shadow so dark logo stays readable on purple gradient */
.signup_page .page_logo img {
	width: auto;
	max-width: 150px;
	height: auto;
	display: block;
	flex: 0 0 auto;
	min-width: 0;
	filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));
}

@media (min-width:30em) {
	.form_outer {
		max-width: 28rem;
	}
}

.form_outer {
	width: calc(100% - 3rem);
	background-color: rgb(255, 255, 255);
	box-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;
	border-radius: 1rem;
	padding: calc(2rem);
	justify-self: center;
	display: grid;
	gap: calc(2rem);
}

.form_heading {
	display: flex;
	flex-flow: column wrap;
	gap: 0.5rem;
	justify-content: start;
	align-items: stretch;
	margin: 0px;
	color: rgb(66, 77, 87);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: 0px;
}

.form_heading h1 {
	margin: 0px;
	color: rgb(5, 27, 44);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
	font-size: 1.75rem;
	font-weight: 600;
	line-height: 2.25rem;
	letter-spacing: -0.00875rem;
}

.signup_google {
	display: grid;
	grid-template-columns: auto min-content min-content;
	gap: 0.5rem;
}

.signup_google button {
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
	border-radius: 0.25rem;
	width: auto;
	padding: 0.35rem;
	background-color: rgb(255, 255, 255);
	line-height: 1.125rem;
	border: 1px solid rgb(192, 193, 245);
	color: rgb(67, 70, 206) !important;
	height: 40px;
	width: 40px;
}

.signup_google .signup_google_button {
	width: 100%;
	padding: 0.5rem 0.75rem;
}

.signup_google_button img {
	max-width: 20px;
	margin-right: 5px;
}

.separator {
	display: grid;
	grid-template-columns: auto max-content auto;
	width: 100%;
	align-items: center;
	gap: 1rem;
	margin: 0px;
}

.separator hr {
	display: block;
	margin: 0px;
	border-width: 1px 0px 0px;
	border-color: rgb(203, 209, 215);
	border-style: solid;
	width: auto;
	height: 0px;
	align-self: unset;
}

.login_form form {
	display: grid;
	row-gap: 1.5rem;
}

.login_form .input_boxes {
	display: flex;
	flex-flow: column wrap;
	gap: 1rem;
	justify-content: start;
	align-items: stretch;
}

.email_input {
	width: 100%;
	position: relative;
	display: flex;
}

.email_input input {
	height: 2.25rem;
	padding: 0.5rem 0.75rem;
	outline: none 0px;
	width: 100%;
	color: rgb(5, 27, 44);
	border-radius: 0.25rem;
	border: 1px solid rgb(203, 209, 215);
	background: rgb(255, 255, 255);
	width: 100%;
	flex: 1 1;
	transition: border-color 100ms ease-in-out, background-color 100ms ease-in-out;
}

.password_input img {
	min-width: 16px;
	width: 16px;
	height: 16px;
	filter: none;
	color: inherit;
	opacity: 1;
	cursor: pointer;
	pointer-events: auto;
	position: absolute;
	right: 0.5rem;
	top: 50%;
	transform: translateY(-50%);
	right: 0.75rem;
}

.password_box span {
	margin: 0px;
	color: rgb(66, 77, 87);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
	/* font-size: 0.75rem; */
	font-weight: 400;
	line-height: 1rem;
	letter-spacing: 0.015rem;
}

.recaptcha {
	position: relative;
}

.recaptcha .checkbox {
	width: 1rem;
	height: 1rem;
	left: 0.25rem;
	top: 0.25rem;
	appearance: none;
	opacity: 0.0001;
	position: absolute;
	margin: 0px !important;
	z-index: 1;
	cursor: pointer;
}

.recaptcha_lable {
	display: flex;
	padding-left: 1.5rem;
	position: relative;
}

.recaptcha_lable label {
	font-weight: normal;
	color: rgb(5, 27, 44);
	margin-bottom: 0px;
	font-size: 1rem;
}

.recaptcha_lable label:before {
	width: 1rem;
	height: 1rem;
	border-radius: 0.125rem;
	top: 0.25rem;
	left: 0px;
	position: absolute;
	border: 1px solid rgb(203, 209, 215);
	display: inline-block;
	content: " ";
	transition: border-color 0.2s ease-in-out;
	background-color: rgb(255, 255, 255);
}

.recaptcha_lable label:after {
	content: '';
	position: absolute;
	left: 0;
	top: 0.25rem;
	display: inline-block;
	transform: rotate(45deg);
	height: 11px;
	width: 6px;
	margin-left: 0.3em;
	border-bottom: 2px solid #78b13f;
	border-right: 2px solid #78b13f;
	opacity: 0;
	visibility: hidden;
	transition: all .3s;
}

.checkbox:checked~.recaptcha_lable label:after {
	opacity: 1;
	visibility: visible;
}

.signup_button {
	display: flex;
	flex-flow: wrap;
	gap: 0px;
	justify-content: start;
	align-items: start;
}

.signup_button button {
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	/* Matches the modern 2FA "Get Started" button: rounded, no border, soft indigo glow. */
	padding: 0.75rem 1rem;
	font-size: 1rem;
	font-weight: 600;
	border-radius: 12px;
	background-color: rgb(67, 70, 206);
	line-height: 1.25rem;
	border: none;
	box-shadow: 0 4px 16px rgba(67, 70, 206, 0.35);
	color: rgb(255, 255, 255) !important;
	width: 100%;
	transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.signup_button button:hover:not(:disabled) {
	transform: translateY(-2px);
	box-shadow: 0 6px 20px rgba(67, 70, 206, 0.45);
}

.signup_button button:disabled {
	cursor: not-allowed;
	box-shadow: none;
}

.already_acc {
	display: flex;
	justify-content: space-between;
	flex-flow: wrap;
	gap: 0px;
	-webkit-box-pack: center;
	align-items: start;
	margin-top: 10px
}

.already_acc span {
	margin: 0px;
	color: rgb(66, 77, 87);
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI;", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol;";
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.25rem;
	letter-spacing: 0px;
}

.already_acc span a {
	display: inline-flex;
	align-items: center;
	column-gap: 0.25rem;
	color: rgb(67, 70, 206);
	overflow-wrap: anywhere;
}

@media (max-width: 768px) {
	.already_acc {
		gap: 10px;
		justify-content: center;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/auth/signup.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,oCAAoC;AACrC;;AAEA;CACC,YAAY;CACZ,kCAAkC;CAClC,cAAc;CACd,SAAS;CACT,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;CACV,uBAAuB;AACxB;;;AAGA,qGAAqG;AACrG;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,iCAAiC;CACjC,QAAQ;CACR,sBAAsB;CACtB,4GAA4G;AAC7G;;AAEA,iHAAiH;AACjH;CACC,sBAAsB;CACtB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,kEAAkE;CAClE,uDAAuD;CACvD,wEAAwE;CACxE,qDAAqD;AACtD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,eAAe;CACf,QAAQ;CAER,uBAAuB;CAEvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CAEpB,uBAAuB;CAEvB,mBAAmB;CACnB,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA,wFAAwF;AACxF;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,cAAc;CACd,YAAY;CACZ,iGAAiG;AAClG;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,wBAAwB;CACxB,oCAAoC;CACpC,0FAA0F;CAC1F,mBAAmB;CACnB,mBAAmB;CACnB,oBAAoB;CACpB,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CAEX,sBAAsB;CAEtB,oBAAoB;CACpB,WAAW;CACX,sBAAsB;CACtB,4JAA4J;CAC5J,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,4JAA4J;CAC5J,kBAAkB;CAClB,gBAAgB;CAChB,oBAAoB;CACpB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,mDAAmD;CACnD,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,oBAAoB;CAEpB,mBAAmB;CAEnB,uBAAuB;CACvB,eAAe;CACf,sBAAsB;CACtB,WAAW;CACX,gBAAgB;CAChB,oCAAoC;CACpC,qBAAqB;CACrB,oCAAoC;CACpC,kCAAkC;CAClC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,4CAA4C;CAC5C,WAAW;CAEX,mBAAmB;CACnB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,WAAW;CACX,yBAAyB;CACzB,gCAAgC;CAChC,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CAET,sBAAsB;CAEtB,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,WAAW;CACX,qBAAqB;CACrB,sBAAsB;CACtB,oCAAoC;CACpC,8BAA8B;CAC9B,WAAW;CACX,SAAY;CACZ,8EAA8E;AAC/E;;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,UAAU;CACV,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,aAAa;CACb,QAAQ;CACR,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,4JAA4J;CAC5J,wBAAwB;CACxB,gBAAgB;CAChB,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,sBAAsB;CACtB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,oCAAoC;CACpC,qBAAqB;CACrB,YAAY;CACZ,yCAAyC;CACzC,oCAAoC;AACrC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,YAAY;CACZ,qBAAqB;CACrB,wBAAwB;CACxB,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,gCAAgC;CAChC,+BAA+B;CAC/B,UAAU;CACV,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CAER,sBAAsB;CAEtB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,oBAAoB;CAEpB,mBAAmB;CAEnB,uBAAuB;CACvB,uFAAuF;CACvF,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,kCAAkC;CAClC,oBAAoB;CACpB,YAAY;CACZ,8CAA8C;CAC9C,oCAAoC;CACpC,WAAW;CACX,iFAAiF;AAClF;;AAEA;CACC,2BAA2B;CAC3B,8CAA8C;AAC/C;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,eAAe;CACf,QAAQ;CACR,wBAAwB;CAExB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,4JAA4J;CAC5J,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CAEpB,mBAAmB;CACnB,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC;EACC,SAAS;EACT,uBAAuB;CACxB;AACD","sourcesContent":["* {\n\tbox-sizing: border-box;\n\tpadding: 0;\n\tmargin: 0;\n}\n\nimg {\n\tmax-width: 100%;\n}\n\na {\n\ttext-decoration: none;\n}\n\n.signup_alert_main {\n\theight: 63px;\n\tdisplay: flex;\n\tborder-radius: 5px;\n\tbackground-color: rgb(249, 215, 216);\n}\n\n.signup_alert1 {\n\theight: 100%;\n\tbackground-color: rgb(229, 75, 77);\n\tcolor: #dfd1d1;\n\twidth: 8%;\n\ttext-align: center;\n\tpadding-top: 15px;\n\tborder-radius: 5px;\n}\n\n.signup_alert2 {\n\tpadding-left: 10px;\n\tpadding-top: 15px;\n\twidth: 92%;\n\tcolor: rgb(106, 34, 36);\n}\n\n\n/* Outer: full-viewport scroll shell only (no grid centering — that clips tall content at the top). */\n.signup_page {\n\tposition: fixed;\n\toverflow-x: auto;\n\toverflow-y: auto;\n\t-webkit-overflow-scrolling: touch;\n\tinset: 0;\n\tbox-sizing: border-box;\n\tbackground: radial-gradient(119.46% 119.46% at 50.12% 119.46%, rgb(129, 131, 236) 0px, rgb(20, 20, 60) 100%);\n}\n\n/* Inner: centers logo + card when short; grows with content when tall so scroll starts from top — no top clip. */\n.signup_page_inner {\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tmin-height: 100vh;\n\tmin-height: 100dvh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 1.5rem;\n\tpadding-top: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-top));\n\tpadding-right: max(0.75rem, env(safe-area-inset-right));\n\tpadding-bottom: max(clamp(1rem, 3vh, 2rem), env(safe-area-inset-bottom));\n\tpadding-left: max(0.75rem, env(safe-area-inset-left));\n}\n\n.page_logo {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-flow: wrap;\n\tgap: 0px;\n\t-webkit-box-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\talign-items: center;\n\ttext-align: center;\n}\n\n.page_logo a {\n\tdisplay: inline-flex;\n\t-webkit-box-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\talign-items: center;\n\tcolumn-gap: 0.25rem;\n\tcolor: rgb(67, 70, 206);\n\toverflow-wrap: anywhere;\n}\n\n/* Wordmark: modest size; subtle shadow so dark logo stays readable on purple gradient */\n.signup_page .page_logo img {\n\twidth: auto;\n\tmax-width: 150px;\n\theight: auto;\n\tdisplay: block;\n\tflex: 0 0 auto;\n\tmin-width: 0;\n\tfilter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.45)) drop-shadow(0 0 1px rgba(255, 255, 255, 0.25));\n}\n\n@media (min-width:30em) {\n\t.form_outer {\n\t\tmax-width: 28rem;\n\t}\n}\n\n.form_outer {\n\twidth: calc(100% - 3rem);\n\tbackground-color: rgb(255, 255, 255);\n\tbox-shadow: rgba(5, 27, 44, 0.12) 0px 1px 8px -1px, rgba(5, 27, 44, 0.08) 0px 3px 4px -1px;\n\tborder-radius: 1rem;\n\tpadding: calc(2rem);\n\tjustify-self: center;\n\tdisplay: grid;\n\tgap: calc(2rem);\n}\n\n.form_heading {\n\tdisplay: flex;\n\tflex-flow: column wrap;\n\tgap: 0.5rem;\n\t-webkit-box-pack: start;\n\tjustify-content: start;\n\t-webkit-box-align: stretch;\n\talign-items: stretch;\n\tmargin: 0px;\n\tcolor: rgb(66, 77, 87);\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tline-height: 1.5rem;\n\tletter-spacing: 0px;\n}\n\n.form_heading h1 {\n\tmargin: 0px;\n\tcolor: rgb(5, 27, 44);\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n\tfont-size: 1.75rem;\n\tfont-weight: 600;\n\tline-height: 2.25rem;\n\tletter-spacing: -0.00875rem;\n}\n\n.signup_google {\n\tdisplay: grid;\n\tgrid-template-columns: auto min-content min-content;\n\tgap: 0.5rem;\n}\n\n.signup_google button {\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\tjustify-content: center;\n\tfont-size: 1rem;\n\tborder-radius: 0.25rem;\n\twidth: auto;\n\tpadding: 0.35rem;\n\tbackground-color: rgb(255, 255, 255);\n\tline-height: 1.125rem;\n\tborder: 1px solid rgb(192, 193, 245);\n\tcolor: rgb(67, 70, 206) !important;\n\theight: 40px;\n\twidth: 40px;\n}\n\n.signup_google .signup_google_button {\n\twidth: 100%;\n\tpadding: 0.5rem 0.75rem;\n}\n\n.signup_google_button img {\n\tmax-width: 20px;\n\tmargin-right: 5px;\n}\n\n.separator {\n\tdisplay: grid;\n\tgrid-template-columns: auto max-content auto;\n\twidth: 100%;\n\t-webkit-box-align: center;\n\talign-items: center;\n\tgap: 1rem;\n\tmargin: 0px;\n}\n\n.separator hr {\n\tdisplay: block;\n\tmargin: 0px;\n\tborder-width: 1px 0px 0px;\n\tborder-color: rgb(203, 209, 215);\n\tborder-style: solid;\n\twidth: auto;\n\theight: 0px;\n\talign-self: unset;\n}\n\n.login_form form {\n\tdisplay: grid;\n\trow-gap: 1.5rem;\n}\n\n.login_form .input_boxes {\n\tdisplay: flex;\n\tflex-flow: column wrap;\n\tgap: 1rem;\n\t-webkit-box-pack: start;\n\tjustify-content: start;\n\t-webkit-box-align: stretch;\n\talign-items: stretch;\n}\n\n.email_input {\n\twidth: 100%;\n\tposition: relative;\n\tdisplay: flex;\n}\n\n.email_input input {\n\theight: 2.25rem;\n\tpadding: 0.5rem 0.75rem;\n\toutline: none 0px;\n\twidth: 100%;\n\tcolor: rgb(5, 27, 44);\n\tborder-radius: 0.25rem;\n\tborder: 1px solid rgb(203, 209, 215);\n\tbackground: rgb(255, 255, 255);\n\twidth: 100%;\n\tflex: 1 1 0%;\n\ttransition: border-color 100ms ease-in-out, background-color 100ms ease-in-out;\n}\n\n.password_input img {\n\tmin-width: 16px;\n\twidth: 16px;\n\theight: 16px;\n\tfilter: none;\n\tcolor: inherit;\n\topacity: 1;\n\tcursor: pointer;\n\tpointer-events: auto;\n\tposition: absolute;\n\tright: 0.5rem;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tright: 0.75rem;\n}\n\n.password_box span {\n\tmargin: 0px;\n\tcolor: rgb(66, 77, 87);\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n\t/* font-size: 0.75rem; */\n\tfont-weight: 400;\n\tline-height: 1rem;\n\tletter-spacing: 0.015rem;\n}\n\n.recaptcha {\n\tposition: relative;\n}\n\n.recaptcha .checkbox {\n\twidth: 1rem;\n\theight: 1rem;\n\tleft: 0.25rem;\n\ttop: 0.25rem;\n\tappearance: none;\n\topacity: 0.0001;\n\tposition: absolute;\n\tmargin: 0px !important;\n\tz-index: 1;\n\tcursor: pointer;\n}\n\n.recaptcha_lable {\n\tdisplay: flex;\n\tpadding-left: 1.5rem;\n\tposition: relative;\n}\n\n.recaptcha_lable label {\n\tfont-weight: normal;\n\tcolor: rgb(5, 27, 44);\n\tmargin-bottom: 0px;\n\tfont-size: 1rem;\n}\n\n.recaptcha_lable label:before {\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 0.125rem;\n\ttop: 0.25rem;\n\tleft: 0px;\n\tposition: absolute;\n\tborder: 1px solid rgb(203, 209, 215);\n\tdisplay: inline-block;\n\tcontent: \" \";\n\ttransition: border-color 0.2s ease-in-out;\n\tbackground-color: rgb(255, 255, 255);\n}\n\n.recaptcha_lable label:after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0.25rem;\n\tdisplay: inline-block;\n\ttransform: rotate(45deg);\n\theight: 11px;\n\twidth: 6px;\n\tmargin-left: 0.3em;\n\tborder-bottom: 2px solid #78b13f;\n\tborder-right: 2px solid #78b13f;\n\topacity: 0;\n\tvisibility: hidden;\n\ttransition: all .3s;\n}\n\n.checkbox:checked~.recaptcha_lable label:after {\n\topacity: 1;\n\tvisibility: visible;\n}\n\n.signup_button {\n\tdisplay: flex;\n\tflex-flow: wrap;\n\tgap: 0px;\n\t-webkit-box-pack: start;\n\tjustify-content: start;\n\t-webkit-box-align: start;\n\talign-items: start;\n}\n\n.signup_button button {\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\tjustify-content: center;\n\t/* Matches the modern 2FA \"Get Started\" button: rounded, no border, soft indigo glow. */\n\tpadding: 0.75rem 1rem;\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tborder-radius: 12px;\n\tbackground-color: rgb(67, 70, 206);\n\tline-height: 1.25rem;\n\tborder: none;\n\tbox-shadow: 0 4px 16px rgba(67, 70, 206, 0.35);\n\tcolor: rgb(255, 255, 255) !important;\n\twidth: 100%;\n\ttransition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.signup_button button:hover:not(:disabled) {\n\ttransform: translateY(-2px);\n\tbox-shadow: 0 6px 20px rgba(67, 70, 206, 0.45);\n}\n\n.signup_button button:disabled {\n\tcursor: not-allowed;\n\tbox-shadow: none;\n}\n\n.already_acc {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-flow: wrap;\n\tgap: 0px;\n\t-webkit-box-pack: center;\n\t-webkit-box-align: start;\n\talign-items: start;\n\tmargin-top: 10px\n}\n\n.already_acc span {\n\tmargin: 0px;\n\tcolor: rgb(66, 77, 87);\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI;\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol;\";\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tline-height: 1.25rem;\n\tletter-spacing: 0px;\n}\n\n.already_acc span a {\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\tcolumn-gap: 0.25rem;\n\tcolor: rgb(67, 70, 206);\n\toverflow-wrap: anywhere;\n}\n\n@media (max-width: 768px) {\n\t.already_acc {\n\t\tgap: 10px;\n\t\tjustify-content: center;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
